import(/* webpackMode: "eager", webpackExports: ["ForgotPasswordScreen"] */ "/usr/src/app/src/screens/auth/sign-in/forgot-password/ForgotPasswordScreen.tsx");
